module.exports = __webpack_public_path__ + "img/hx-ydhyy-w.a0939f53.svg";